import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { UserService } from '@/core/services/user.service';
import { User } from '@/core/models/user';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';


@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of filteredModel; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu {

    roles: string[] = [];
    filteredModel: any[] = [];
    model: any[] = [];

    constructor(
        private userTokenService: UserService,
        private http: HttpClient
    ) {
        this.roles = this.userTokenService.getRoles();
        this.buildModel();
        this.filteredModel = this.filterMenuItems(this.model);
    }

    createDownloadCommand(event: any): void {
        const pdfPath = '/assets/docs/Manual_JornadaDigital_Web.pdf';
        const filename = 'Manual_JornadaDigital_Web.pdf';
        this.downloadPdf(pdfPath, filename);
    }

    downloadPdf(pdfPath: string, filename: string = 'documentacao.pdf'): void {
        // Faz download do PDF local usando HttpClient
        this.http.get(pdfPath, { responseType: 'blob' }).subscribe({
            next: (blob) => {
                saveAs(blob, filename);
            },
            error: (error) => {
                console.error('Erro ao fazer download do PDF:', error);
                // Fallback: tenta abrir o arquivo em nova aba
                window.open(pdfPath, '_blank');
            }
        });
    }

    hasAccess(item: any): boolean {
        if (!item.roles || !item.roles.length) {
            return true;
        }
        return this.roles.some(role => item.roles.includes(role));
    }

    filterMenuItems(items: any[]): any[] {
        return items
            .map(item => {
                // Handle separators
                if (item.separator) {
                    return item;
                }

                // Clone the item to avoid mutating the original
                const clonedItem = { ...item };

                // If the item has sub-items, filter them recursively
                if (clonedItem.items && clonedItem.items.length > 0) {
                    clonedItem.items = this.filterMenuItems(clonedItem.items);

                    // If no sub-items remain after filtering, check if parent has direct access
                    if (clonedItem.items.length === 0 && !this.hasAccess(clonedItem)) {
                        return null;
                    }

                    // If parent doesn't have direct access but has accessible children, keep it
                    if (clonedItem.items.length > 0) {
                        return clonedItem;
                    }

                    return null;
                }

                // For items without sub-items, check direct access
                return this.hasAccess(clonedItem) ? clonedItem : null;
            })
            .filter(item => item !== null);
    }

    buildModel(): void {
        this.model = [
        {
            label: 'CONTROLE DE JORNADA',
            roles: ['P_MAX', 'HOME_CON'],
            items: [
                {
                    label: 'Consumo de Bateria',
                    icon: 'pi pi-bolt',
                    routerLink: ['/consumo-bateria/lista'],
                    roles: ['P_MAX', 'REL_BATERIA_CON'],
                },
                {
                    label: 'Controle de Jornada',
                    icon: 'pi pi-briefcase',
                    routerLink: ['/controle-jornada/lista'],
                    roles: ['P_MAX', 'CONTROLE_JORNADA_CON']
                },
                {
                    label: 'Controle de Localização',
                    icon: 'pi pi-map-marker',
                    routerLink: ['/controle-localizacao/lista'],
                    roles: ['P_MAX', 'REL_HOME_LOCALIZACAO_ROTA_EXECUCAO_CON']
                },
                {
                    label: 'Relatório de Coordenadas',
                    icon: 'pi pi-compass',
                    routerLink: ['/relatorio-coordenadas/lista'],
                    roles: ['P_MAX', 'REL_COORDENADAS_CON']
                },
                {
                    label: 'Horas Extras',
                    icon: 'pi pi-clock',
                    roles: ['P_MAX', 'HOME_CON'],
                    items: [
                        {
                            label: 'Horas Extras Produtivas',
                            routerLink: ['/hora-extra-produtiva/lista'],
                            roles: ['P_MAX', 'REL_HOME_ACOMPANHAMENTO_HE_CON'],
                        },
                        {
                            label: 'Horas Extras Notificadas',
                            routerLink: ['/hora-extra-notificada/lista'],
                            roles: ['P_MAX', 'REL_HOME_HE_NAUTORIZADAS_CON'],
                        },
                    ]
                },
                {
                    label: 'Registros',
                    icon: 'pi pi-list',
                    roles: ['P_MAX', 'HOME_CON'],
                    items: [
                        {
                            label: 'Registros com Ressalva',
                            routerLink: ['/registros-com-ressalva/lista'],
                            roles: ['P_MAX', 'REL_HOME_PONTO_CON'],
                        },
                        {
                            label: 'Registro de Ponto',
                            routerLink: ['/relatorio-acompanhamento-ponto/lista'],
                            roles: ['P_MAX', 'REL_HOME_PONTO_CON'],
                        }
                    ]
                },
                {
                    label: 'Relatórios de Tempo',
                    icon: 'pi pi-chart-line',
                    roles: ['P_MAX', 'HOME_CON'],
                    items: [
                        {
                            label: 'Tempo da Atividade',
                            routerLink: ['/relatorio-tempo-atividade/lista'],
                            roles: ['P_MAX', 'REL_ATIVIDADE_TEMPO_CON'],
                        },
                        // {
                        //     label: 'Tempo da Matinal',
                        //     routerLink: ['/relatorio-tempo-matinal/lista'],
                        //     roles: ['P_MAX', 'REL_FUNCIONARIO_MATINAL_CON'],
                        // }, Soft deleted
                        {
                            label: 'Tempo de Visita',
                            routerLink: ['/relatorio-tempo-visita/lista'],
                            roles: ['P_MAX', 'REL_TEMPO_VISITA_CON'],
                        }
                    ]
                },
                {
                    label: 'Log de Login',
                    icon: 'pi pi-sign-in',
                    routerLink: ['/log-login/lista'],
                    roles: ['MAX', 'LOG_LOGIN_CON'],
                },
                {
                    label: 'Log de Reset de Login',
                    icon: 'pi pi-key',
                    routerLink: ['/log-login-reset/lista'],
                    roles: ['MAX', 'LOG_LOGIN_CON'],
                },
            ]
        },
        // {
        //     label: 'help',
        //     icon: 'pi pi-question-circle',
        //     items: [
        //         {
        //             label: 'Documentação',
        //             icon: 'pi pi-file',
        //             url: 'https://www.flipsnack.com/5B7B5FD6AED/manual_jornadadigital_web',
        //             target: '_blank'
        //         },
        //         {
        //             label: 'Download Documentação',
        //             icon: 'pi pi-download',
        //             command: this.createDownloadCommand.bind(this)
        //         }
        //     ]
        // },
        {
            label: 'MONITORAMENTO',
            roles: ['P_MAX'],
            items: [
                {
                    label: 'Monitor',
                    icon: 'pi pi-chart-bar',
                    routerLink: ['/monitor'],
                    roles: ['P_MAX', 'MONITOR_CON'],
                }
            ]
        },
        //{ separator: true },
        {
            label: 'OPERAÇÃO',
            roles: ['P_MAX', 'MENU_REL_OPERACIONAIS_CON'],
            items: [
                {
                    label: 'Estrutura Geográfica',
                    icon: 'pi pi-map',
                    routerLink: ['/estrutura-geografica'],
                    roles: ['P_MAX', 'IMP_DADOS_HIERARQUIA_CON'],
                },
                {
                    label: 'Importações',
                    icon: 'pi pi-upload',
                    roles: ['P_MAX', 'IMP_VISIT_LIST_CON'],
                    items: [
                        {
                            label: 'Importação de Hierarquia Geográfica',
                            routerLink: ['/importacao/hierarquia-geografica'],
                            roles: ['P_MAX', 'IMP_DADOS_HIERARQUIA_CON']
                        },
                        {
                            label: 'Importação de Ponto de Matinal',
                            routerLink: ['/importacao/ponto-matinal'],
                            roles: ['P_MAX', 'IMP_PONTO_PARTIDA_SEMANAL_CON'],
                        },
                        //{
                        //     label: 'Importação de Terceiros',
                        //     routerLink: ['/importacao/func-ter'],
                        //     roles: ['P_MAX', 'IMP_FUNC_TERC_CON'],
                        // },
                        {
                            label: 'Importação de Visit List',
                            routerLink: ['/importacao/visit-list'],
                            roles: ['P_MAX', 'IMP_VISIT_LIST_CON'],
                        },
                    ]
                },
                {
                    label: 'Planejamento de Escala',
                    icon: 'pi pi-calendar-plus',
                    routerLink: ['/planejamento-escala'],
                    roles: ['P_MAX', 'ESCALA_PLANEJAMENTO_CON'],
                },
                {
                    label: 'Relação de Funcionários',
                    icon: 'pi pi-users',
                    routerLink: ['/relacao-funcionarios'],
                    roles: ['P_MAX', 'ACESSO_RELACAO_FUNCIONARIOS_CON'],
                },
                // {
                //     label: 'Relação de Visitas',
                //     icon: 'pi pi-briefcase',
                //     routerLink: ['/atividade-list'],
                //     roles: ['P_MAX', 'RELACAO_ATIVIDADE_CON'],
                // },
            ]
        },
        {
            label: 'ADMIN',
            roles: ['P_MAX', 'MONITOR_INTERFACE_CON'],
            items: [
                {
                    label: 'Configuração de Acesso',
                    icon: 'pi pi-cog',
                    roles: ['P_MAX', 'ACESSO_USUARIO_CON'],
                    items: [
                        {
                            label: 'Relação de Perfil',
                            routerLink: ['/perfil/lista'],
                            roles: ['P_MAX', 'ACESSO_PERFIL_CON'],
                        },
                        {
                            label: 'Relação de Permissões',
                            routerLink: ['/rotina/lista'],
                            roles: ['P_MAX', 'ACESSO_ROTINA_CON'],
                        },
                        {
                            label: 'Relação de Usuários',
                            routerLink: ['/relacao-usuarios/lista'],
                            roles: ['P_MAX', 'ACESSO_USUARIO_CON'],
                        },
                    ]
                },
                {
                    label: 'Relação de Ponto Inválido',
                    icon: 'pi pi-times-circle',
                    routerLink: ['/ponto-invalido/lista'],
                    roles: ['P_MAX', 'RelacaoPontoInvalido_CON'],
                },

                {
                    label: 'Reprocessamento de Rotina',
                    icon: 'pi pi-refresh',
                    routerLink: ['/profile/list'],
                    roles: ['P_MAX', 'AJUSTE_PONTO_CON'],
                }
            ]
        }
        ];
    }
}
